import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { CoreModule, DialogComponent, FormComponent, OffersType } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../../../store/store.model';
import OFFERS_ACTIONS from '../../../../store/offers/offers.actions';

@Component({
    selector: 'ivva-price-filter',
    templateUrl: './price-filter.component.html',
    styleUrls: ['./price-filter.component.scss'],
    imports: [CoreModule, TranslateModule, DialogComponent]
})
export class PriceFilterComponent extends FormComponent implements OnInit {
	@Input()
	type: OffersType | null;

	max: number = 999;
	showInfo = signal(false);

	readonly OffersType = OffersType;

	private readonly fb = inject(FormBuilder);
	private readonly store = inject(Store<IvvaStore>);

	get minimum(): number {
		return this.form?.get('min')?.value || 0;
	}

	get maximum(): number {
		return this.form?.get('max')?.value || this.max;
	}

	ngOnInit() {
		this.createForm();

		if (this.type === OffersType.ACCOMMODATION) {
			this.store
				.select('offers', 'maxPriceAccommodation')
				.pipe(takeUntil(this.destroyed$))
				.subscribe((price) => {
					this.max = price;
					this.store.next(OFFERS_ACTIONS.setFilters({ filters: { maxPrice: this.max } }));
					this.form?.get('max')?.setValue(this.max, { emitEvent: false });
				});
		} else {
			this.store
				.select('offers', 'maxPriceDaytrip')
				.pipe(takeUntil(this.destroyed$))
				.subscribe((price) => {
					this.max = price;
					this.store.next(OFFERS_ACTIONS.setFilters({ filters: { maxPrice: this.max } }));
					this.form?.get('max')?.setValue(this.max, { emitEvent: false });
				});
		}
	}

	checkValues() {
		if (this.minimum > this.maximum) {
			this.form?.get('min')?.setValue(0);
			this.form?.get('max')?.setValue(this.max);
		}
	}

	private createForm() {
		this.form = this.fb.group({
			min: [0],
			max: [this.max],
		});

		this.form?.valueChanges.pipe(takeUntil(this.destroyed$), debounceTime(300)).subscribe((value) => {
			const filters = {
				minPrice: +value.min,
				maxPrice: +value.max,
			};

			this.store.next(OFFERS_ACTIONS.setFilters({ filters }));
		});

		this.store
			.select('offers', 'filters')
			.pipe(takeUntil(this.destroyed$))
			.subscribe((value) => {
				this.form?.setValue(
					{
						min: value.minPrice,
						max: value.maxPrice,
					},
					{ emitEvent: false }
				);
			});
	}
}
